<script setup lang="ts">
// 64px top bar of the desktop shell: kicker + page name, tagline, account entry.
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { openAuth } from '../stores/overlays'
import { session } from '../stores/session'
import { shellInfo } from './nav'
import ProfileAvatar from '../components/ProfileAvatar.vue'

const route = useRoute()
const router = useRouter()
const title = computed(() => shellInfo(route.path).title)
const name = computed(() => session.user?.displayName || session.user?.email?.split('@')[0] || '我的')
</script>

<template>
  <header class="workspace-bar">
    <div><span>GUIDE EXAM LAB</span><b id="workspaceTitle">{{ title }}</b></div>
    <p>官方考纲、笔试题库与错题间隔重现</p>
    <div class="account-entry" id="accountEntry">
      <button v-if="session.signedIn" type="button" class="account-user-btn" title="查看我的账号与进度" @click="router.push('/me')">
        <ProfileAvatar :avatar="session.user?.avatar" :name="name" /><span>{{ name }}</span>
      </button>
      <button v-else-if="session.loaded" type="button" class="account-login-btn" @click="openAuth('login')">登录 / 注册</button>
    </div>
  </header>
</template>
